import { render } from "./ZennArticleSection.vue?vue&type=template&id=d88971d0&scoped=true&ts=true"
import script from "./ZennArticleSection.vue?vue&type=script&lang=ts"
export * from "./ZennArticleSection.vue?vue&type=script&lang=ts"

import "./ZennArticleSection.vue?vue&type=style&index=0&id=d88971d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d88971d0"]])

export default __exports__